export default __webpack_public_path__ + "53bee7d76febf997d18567b351b16cc5.png";